import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { HintIconComponent } from '../../../hint-icon/hint-icon.component';

export type ChangeTaxDialogData = undefined
export enum ChangeTaxOption {
    Cancel = 'cancel',
    AdjustGross = 'adjustGross',
    AdjustNet = 'adjustNet'
}

export type ChangeTaxDialogReturnData = ChangeTaxOption;


@Component({
    selector: 'app-change-tax-dialog',
    standalone: true,
    imports: [CommonModule, AppButtonModule, MatLegacyDialogModule, HintIconComponent],
    templateUrl: './change-tax-dialog.component.html',
    styleUrls: ['./change-tax-dialog.component.scss'],
})
export class ChangeTaxDialogComponent {
    ChangeTaxOption = ChangeTaxOption;
}



